import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import {
  msalInstance,
  initialiseMsal,
} from "../authConfig";

const startApp = async () => {
  await initialiseMsal();

  const rootElement = document.getElementById("root");

  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);

    root.render(
      <React.StrictMode>
        <App msaLInstance={msalInstance} />
      </React.StrictMode>
    );
  }
};

startApp();